module.exports = __webpack_public_path__ + "static/wah-text-f1e37f822ffb0e77fc6297bebc5a259a.svg";